import { render, staticRenderFns } from "./RelatorioFaltas.vue?vue&type=template&id=62ce27da"
import script from "./RelatorioFaltas.vue?vue&type=script&lang=js"
export * from "./RelatorioFaltas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports